// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"ee373747","703":"c0505fb0"}[chunkId] + ".chunk.js";
};